const apiUrl = process.env.REACT_APP_API_URL;
const BASE = `${apiUrl}:8072/stock`;

function headers(page: string) {
    return {'Content-Type': 'application/json', 'pantalla': page};
}

// ===== Comandes a lliurar (escoles) =====

export const GetGestioStock = async (page: string): Promise<any[]> => {
    try {
        const r = await fetch(`${BASE}/gestio`, {method: 'GET', headers: headers(page)});
        if (!r.ok) return [];
        const d = await r.json();
        return Array.isArray(d) ? d : [];
    } catch (e) { console.log('GetGestioStock', e); return []; }
};

export const PostGestioStock = async (page: string, inici: string, fin: string): Promise<boolean> => {
    try {
        const r = await fetch(`${BASE}/gestio?inici=${inici}&fin=${fin}`, {method: 'POST', headers: headers(page)});
        return r.ok;
    } catch (e) { console.log('PostGestioStock', e); return false; }
};

export const DeleteGestioStock = async (page: string, id: number): Promise<boolean> => {
    try {
        const r = await fetch(`${BASE}/gestio/${id}`, {method: 'DELETE', headers: headers(page)});
        return r.ok;
    } catch (e) { console.log('DeleteGestioStock', e); return false; }
};

export const GetProductesGestioStock = async (page: string, id: number): Promise<any[]> => {
    try {
        const r = await fetch(`${BASE}/gestio/${id}/productes`, {method: 'GET', headers: headers(page)});
        if (!r.ok) return [];
        const d = await r.json();
        return Array.isArray(d) ? d : [];
    } catch (e) { console.log('GetProductesGestioStock', e); return []; }
};

export const PostProducteLliurat = async (
    page: string, idGestio: number, idIngredient: number, idEscola: number, quantitat: number, lliurat: number
): Promise<boolean> => {
    try {
        const r = await fetch(
            `${BASE}/gestio/${idGestio}/lliurat?idIngredient=${idIngredient}&idEscola=${idEscola}&quantitat=${quantitat}&lliurat=${lliurat}`,
            {method: 'POST', headers: headers(page)}
        );
        return r.ok;
    } catch (e) { console.log('PostProducteLliurat', e); return false; }
};

// ===== Comandes pendents de rebre =====

export const GetComandesPendentsRebre = async (page: string): Promise<any[]> => {
    try {
        const r = await fetch(`${BASE}/pendents`, {method: 'GET', headers: headers(page)});
        if (!r.ok) return [];
        const d = await r.json();
        return Array.isArray(d) ? d : [];
    } catch (e) { console.log('GetComandesPendentsRebre', e); return []; }
};

export const DeleteComandaPendentRebre = async (page: string, id: number): Promise<boolean> => {
    try {
        const r = await fetch(`${BASE}/pendents/${id}`, {method: 'DELETE', headers: headers(page)});
        return r.ok;
    } catch (e) { console.log('DeleteComandaPendentRebre', e); return false; }
};

export const MoveComandaToStock = async (page: string, id: number): Promise<boolean> => {
    try {
        const r = await fetch(`${BASE}/pendents/${id}/rebre`, {method: 'POST', headers: headers(page)});
        return r.ok;
    } catch (e) { console.log('MoveComandaToStock', e); return false; }
};
